export enum RouteEnum {
  home = "/",
  login = "/auth/login",
  walletConnected = "/connect-wallet",
  register = "/auth/register",
  forgotPassword = "/forgot-password",
  dashboard = "/dashboard",
  activity = "/dashboard/activity",
  exploreIp = "/dashboard/exploreIp",
  savedIp = "/dashboard/saved-ip",
  accountPreferences = "/setting/account-preferences",
  contactInfo = "/setting/contact-info",
  pendingForActivation = "/pendingForActivation",
  authenticationResult = "/authenticationResult",
  generalPreferences = "/setting/general-preferences",
  profile = "/profile/",
  mint = "/mint",
  whitePaper = "/",
  aboutUs = "/about-us",
  faq = "/faq",
  tos = "/tos",
  privacy = "/privacy",
  searchResult = "/search",
  publicIpRoute = "/ip/:ipDetail",
  publicIp = "/ip/",
  news = "/news/:newsid",
  setting = "/setting/general-preferences",
}

export enum AuthEnum {
  accessToken = "accessToken",
  userId = "userId",
  role = "role",
  accessTokenExpiration = "accessTokenExpiration",
  referralCode = "referralCode",
}
